import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';

function ImageUpload() {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageFormat, setImageFormat] = useState(null);
    const [showItemSelect, setShowItemSelect] = useState(false);

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const backendBaseUrl = `${apiLocalUrl}`;

 
    useEffect(() => {
        fetch(`${apiBaseUrl}/getCategories/JAPAN_ACCESORIES`)
            .then((res) => res.json())
            .then((data) => setCategories(data));
    }, []);

    useEffect(() => {
        if (selectedCategory) {
            fetch(`${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=${selectedCategory}`)
                .then((res) => res.json())
                .then((data) =>
                    setItems(data.map(item => ({ Id: item.ID, ItemName: item.ItemName })))
                );
        }
    }, [selectedCategory]);

    const handleCategoryChange = (selected) => {
        if (selected) {
            setSelectedCategory(selected.value);
            setSelectedItem('');
            setSelectedImage(null);
            setShowItemSelect(true);
        } else {
            setSelectedCategory('');
            setShowItemSelect(false);
        }
    };

    const handleItemChange = (selected) => {
        if (selected) {
            setSelectedItem(selected.value);
            setSelectedImage(null);
        } else {
            setSelectedItem('');
        }
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!selectedItem || !file) return;

        setSelectedImage(file);
        const format = file.name.split('.').pop().toLowerCase();
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch(`${backendBaseUrl}/upload-image/${selectedItem}.${format}`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                window.alert(`Image uploaded successfully with the name: ${data}`);
                setImageFormat(format);
            } else {
                window.alert('Image upload failed');
            }
        } catch (error) {
            console.error(error);
            window.alert('Image Upload Successfully!');
        }
    };

    return (
        <div className="max-w-2xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-2xl">
            <h1 className="text-3xl font-bold text-center text-indigo-600 mb-6">Upload Product Image</h1>

            <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Category</label>
                <Select
                    onChange={handleCategoryChange}
                    isClearable
                    isSearchable
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={categories.map((cat) => ({ value: cat.Id, label: cat.Name }))}
                />
            </div>

            {showItemSelect && (
                <div className="mb-5">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Item</label>
                    <Select
                        onChange={handleItemChange}
                        isClearable
                        isSearchable
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={items.map((item) => ({ value: item.Id, label: item.ItemName }))}
                    />
                </div>
            )}

            {selectedItem && (
                <div className="mb-6">
                    <label htmlFor="imageUpload" className="block text-sm font-medium text-gray-700 mb-2">
                        Upload Image
                    </label>
                    <input
                        id="imageUpload"
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none hover:border-indigo-500 transition duration-150"
                    />
                </div>
            )}

            {selectedImage && (
                <div className="mt-6">
                    <h2 className="text-lg font-semibold mb-2 text-gray-800">Image Preview:</h2>
                    <img
                        src={URL.createObjectURL(selectedImage)}
                        alt="Preview"
                        className="w-full max-h-80 object-contain rounded-lg shadow-md border border-gray-300"
                    />
                </div>
            )}
        </div>
    );
}

export default ImageUpload;
